import { createRouter, createWebHashHistory } from 'vue-router';

import RouteNames from '@/constants/RouteNames';
import { authCallbackRoute, errorNotFoundRoute, errorUnauthorizedRoute, homeRoute, loginRoute } from '@/router/routes/core';
import { employeeRoutes } from '@/router/routes/employee';
import { foremanRoutes } from '@/router/routes/foreman';
import { hardwareRoutes } from '@/router/routes/hardware';
import { movementRoutes } from '@/router/routes/movement';
import { projectRoutes } from '@/router/routes/project';
import { useSessionStore } from '@/stores/session';
import { supabase } from '@/supabase';
import { scrollPageToTop } from '@/helpers/app';

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes: [
    // Features
    movementRoutes,
    employeeRoutes,
    foremanRoutes,
    hardwareRoutes,
    projectRoutes,
    // Core
    loginRoute,
    authCallbackRoute,
    errorUnauthorizedRoute,
    homeRoute,
    errorNotFoundRoute,
  ],
});

// Global navigation guard to intercept OAuth callback parameters
router.beforeEach(async (to, from, next) => {
  scrollPageToTop();

  // Check for auth parameters in the URL
  const sessionStore = useSessionStore();
  // If user is authenticated and trying to access login page, redirect to movements
  if (sessionStore.isAuthenticated && to.name === RouteNames.Login) {
    next({ name: RouteNames.Movement.List });
    return;
  }

  const isAuthRoute = to.matched.some((record) => record.meta.requiresAuth === false);

  // Allow access to routes that don't require auth
  if (isAuthRoute) {
    next();
    return;
  }

  // Force session check before authentication verification
  const { data } = await supabase.auth.getSession();
  if (data?.session) {
    await sessionStore.setSession(data.session);
  }

  if (!sessionStore.isAuthenticated) {
    next({ name: RouteNames.Login });
    return;
  }

  next();
});

export default router;
